import { render, staticRenderFns } from "./Signout.vue?vue&type=template&id=00b9e92d"
import script from "./Signout.vue?vue&type=script&lang=js"
export * from "./Signout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports